<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 style="text-align: center;" class="titulo">LISTADO DE FACTURAS DE RECURSOS FINANCIEROS</h2>
    </div>

    <div class="contenedor-botones">
        <button type="button" class="btn-agregar" title="AGREGAR XML" (click)="abrirAgregarXML()">
      <i class="fas fa-file-invoice-dollar"></i> AGREGAR COMPROBACIÓN
    </button>

        <button type="button" class="btn-agregar" title="GENERAR EXCEL" (click)="Generaldatos()">
      <i class="fa-solid fa-file-excel"></i> EXCEL GENERAL
    </button>
    </div>

    <div class="table-wrapper">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">
            <thead>
                <tr>
                    <th>Comprobaciones</th>
                </tr>
            </thead>
            <tbody>

                <ng-container *ngFor="let viati of comprobacionesAgrupadas">

                    <tr class="fila-principal">

                        <td colspan="12" class="p-0">

                            <div class="d-flex align-items-center p-3 border-bottom">

                                <div style="width: 18%;">

                                    <button class="btn btn-sm btn-outline-primary me-2" (click)="toggleDetalle(viati)">

                    <i class="fa"
                       [ngClass]="viati.expandido ? 'fa-chevron-down' : 'fa-chevron-right'">
                    </i>

                  </button> {{ viati.nombreplantel }}

                                </div>

                                <div style="width: 12%;">
                                    {{ viati.oficio }}
                                </div>

                                <div style="width: 10%;">
                                    {{ viati.numempleado }}
                                </div>

                                <div style="width: 18%;">
                                    {{ viati.nombre }}
                                </div>

                                <div style="width: 20%;" class="text-break">
                                    {{ viati.detalles[0]?.uuid }}
                                </div>

                                <div style="width: 10%;" class="text-primary fw-bold">
                                    {{ viati.detalles.length }} XML
                                </div>

                                <div style="width: 12%;" class="text-end">

                                    <button type="button" class="btn btn-outline-dark btn-sm me-1" (click)="verComprobacion(viati)">
                    <i class="fa fa-eye"></i>
                  </button>

                                    <button type="button" class="btn btn-outline-dark btn-sm me-1" (click)="editarComprobacion(viati)">
                    <i class="fa fa-edit"></i>
                  </button>

                                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarComprobacion(viati)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="Comprobaciondatos(viati)">
                    <i class="fa-solid fa-file-excel"></i>
                  </button>
                                </div>

                            </div>

                            <div *ngIf="viati.expandido" class="p-3 bg-light">

                                <table class="table table-bordered table-sm mb-0">

                                    <thead class="table-secondary">

                                        <tr>
                                            <th>UUID</th>
                                            <th>Proveedor</th>
                                            <th>RFC proveedor</th>
                                            <th>Total de CFDI</th>
                                            <th>Bueno Por</th>

                                            <th>ISR</th>
                                            <th>Observación</th>
                                            <th>Eliminar XML</th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr *ngFor="let detalle of viati.detalles">

                                            <td>{{ detalle.uuid }}</td>

                                            <td>{{ detalle.nombre_emisor }}</td>

                                            <td>{{ detalle.rfc_emisor }}</td>


                                            <td>
                                                $ {{ detalle.total | number:'1.2-2' }}
                                            </td>
                                            <td>
                                                $ {{ detalle.buenopor | number:'1.2-2' }}
                                            </td>

                                            <td>
                                                $ {{ detalle.isr | number:'1.2-2' }}
                                            </td>
                                            <td class="text-center">

                                                <button *ngIf="detalle.observacion != null" type="button" class="btn btn-outline-dark btn-sm" data-toggle="modal" data-target="#observacion" (click)="abrirObservacion(detalle)">

                          <i class="fa fa-comments"></i>

                        </button>

                                            </td>
                                            <td class="text-center">

                                                <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarXML(detalle.uuid)">

                          <i class="fa-solid fa-trash"></i>

                        </button>

                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                            </td>

                    </tr>

                </ng-container>

            </tbody>
        </table>
    </div>
</div>

<div class="modal fade" id="Agrexml" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">
                    {{ modo === 'nuevo' ? 'AGREGAR COMPROBACIÓN' : modo === 'editar' ? 'EDITAR COMPROBACIÓN' : 'VER COMPROBACIÓN' }}
                </h2>
            </div>

            <div class="modal-body-asig">
                <div class="container-asig">

                    <div class="row mt-3">
                        <div class="col col-lg-3">
                            <label>Plantel:</label>
                            <select [(ngModel)]="viaticos.plantel" name="plantel" id="inputPlantel" class="form-control" required [class.is-invalid]="plantel.invalid && plantel.touched" ngModel #plantel="ngModel" (change)='traerDatoempleado(plantel.value)' [disabled]="modo === 'ver'">
                <option value>Seleccione...</option>
                <ng-container *ngFor="let plantel of planteles">
                  <option *ngIf="plantel.esactivo==true" [value]="plantel.idplantel">
                    {{plantel.claveplantel}} - {{plantel.nombreplantel}}
                  </option>
                </ng-container>
              </select>
                            <small *ngIf="plantel.errors?.required && plantel.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
                        </div>
                        <div *ngIf="viaticos.plantel" class="col-lg-6 position-relative">

                            <label>Empleado:</label>

                            <input type="text" class="form-control" [(ngModel)]="busquedaEmpleado" (input)="filtrarEmpleados()" placeholder="Buscar empleado por nombre o número" [disabled]="modo === 'ver'">

                            <div class="list-group position-absolute w-100 shadow" *ngIf="empleadosFiltrados.length && busquedaEmpleado && modo !== 'ver'" style="z-index: 1050; max-height: 250px; overflow-y: auto;">

                                <button type="button" class="list-group-item list-group-item-action" *ngFor="let emp of empleadosFiltrados" (click)="seleccionarEmpleado(emp)">

                  <strong>{{ emp.numpersonal }}</strong>
                  -
                  {{ emp.nombre }}
                  {{ emp.appaterno }}
                  {{ emp.apmaterno }}

                </button>

                            </div>

                        </div>
                    </div>



                    <div *ngIf="empleadoSeleccionado" class="mt-4">

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <strong>CURP:</strong>
                                <p>{{ empleadoSeleccionado.curp }}</p>
                            </div>
                            <div class="col-lg-4">
                                <strong>RFC:</strong>
                                <p>{{ empleadoSeleccionado.rfc }}</p>
                            </div>
                            <div class="col-lg-4">
                                <strong>No. Empleado:</strong>
                                <p>{{ empleadoSeleccionado.numpersonal }}</p>
                            </div>
                        </div>

                        <hr>

                        <div class="row mt-5">

                            <div class="col-lg-2">
                                <label>Oficio</label>
                                <input class="form-control" [(ngModel)]="viaticos.oficio" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-2">
                                <label>Cargo bancario</label>
                                <input type="date" class="form-control" [(ngModel)]="viaticos.cargoBancario" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-3">
                                <label>Subsidio</label>
                                <select class="form-control w-100" [(ngModel)]="viaticos.subsidio" [disabled]="modo === 'ver'">
                  <option value="" disabled selected>Seleccione una partida</option>
                  <option *ngFor="let s of subsidio" [value]="s.descripcion">
                    {{ s.descripcion }}
                  </option>
                </select>
                            </div>




                            <div class="col-lg-3">
                                <label>Motivo de la comisión</label>
                                <input class="form-control" [(ngModel)]="viaticos.motivo" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-2">
                                <label>Lugar de la comisión</label>
                                <input class="form-control" [(ngModel)]="viaticos.lugar" [disabled]="modo === 'ver'">
                            </div>
                        </div>


                        <div class="row mt-5">
                            <div class="col-lg-2">
                                <label>Fecha ida</label>
                                <input type="date" class="form-control" [(ngModel)]="viaticos.fechaIda" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-2">
                                <label>Fecha regreso</label>
                                <input type="date" class="form-control" [(ngModel)]="viaticos.fechaRegreso" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-2">
                                <label>Importe C.B.</label>
                                <input type="number" class="form-control" [(ngModel)]="viaticos.importecb" (input)="actualizarComprobacionYReintegro()" [disabled]="modo === 'ver'">
                            </div>
                            <div class="col-lg-2">
                                <label>Comprobado</label>
                                <input type="number" class="form-control" [(ngModel)]="viaticos.Comprobado" disabled>
                            </div>
                            <div class="col-lg-2">
                                <label>
                  {{ viaticos.Reintegro >= 0 ? 'Reintegro' : 'Saldo a favor' }}
                </label>

                                <input type="number" class="form-control" [ngModel]="montoReintegro" disabled>
                            </div>
                            <div class="col-lg-2">
                                <label>Fecha reintegro</label>
                                <input type="date" class="form-control" [(ngModel)]="viaticos.fechaReintegro" [disabled]="modo === 'ver'">
                            </div>
                        </div>



                        <div *ngIf="partidas.length">

                            <hr class="mt-4">
                            <h4 class="mt-3">Partidas agregadas</h4>

                            <div class="accordion mt-3">

                                <div class="accordion-item" *ngFor="let partida of partidas; let i = index">

                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#partida' + i">
                      Partida {{ partida.clave }}
                      <span class="badge bg-primary ms-3">
                        {{ partida.xmls.length }} XML
                      </span>
                    </button>
                                    </h2>

                                    <div [id]="'partida' + i" class="accordion-collapse collapse">

                                        <div class="accordion-body">
                                            <div class="d-flex justify-content-end gap-2 mb-2">
                                                <button class="btn btn-warning btn-sm" (click)="editarPartida(i)" *ngIf="modo !== 'ver'">
                          Editar
                        </button>

                                                <button class="btn btn-danger btn-sm" (click)="eliminarPartida(i)" *ngIf="modo !== 'ver'">
                          Eliminar
                        </button>
                                            </div>

                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Folio</th>
                                                        <th>Proveedor</th>
                                                        <th>RFC Emisor</th>
                                                        <th>Folio</th>
                                                        <th>Subtotal</th>
                                                        <th>Total</th>
                                                        <th>Bueno por</th>
                                                        <th>Restante</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let x of partida.xmls">
                                                        <td>{{ x.folio }}</td>
                                                        <td>{{ x.nombre_emisor }}</td>
                                                        <td>{{ x.rfc_emisor }}</td>
                                                        <td>{{ x.uuid }}</td>
                                                        <td>$ {{ x.subtotal | number:'1.2-2' }}</td>
                                                        <td>$ {{ x.total | number:'1.2-2' }}</td>
                                                        <td class="text-success">
                                                            $ {{ x.buenoPor | number:'1.2-2' }}
                                                        </td>
                                                        <td class="text-danger">
                                                            $ {{ x.restante | number:'1.2-2' }}
                                                        </td>
                                                    </tr>
                                                    <tr class="table-light fw-bold">
                                                        <td colspan="5" class="text-end">Totales</td>

                                                        <td>
                                                            $ {{ getTotal(partida.xmls, 'total') | number:'1.2-2' }}
                                                        </td>

                                                        <td class="text-success">
                                                            $ {{ getTotal(partida.xmls, 'buenoPor') | number:'1.2-2' }}
                                                        </td>

                                                        <td class="text-danger">
                                                            $ {{ getTotal(partida.xmls, 'restante') | number:'1.2-2' }}
                                                        </td>
                                                    </tr>



                                                </tbody>

                                            </table>

                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <hr class="mt-4">
                        <div *ngIf="modo !== 'ver'">
                            <h4 class="mt-3">Partida y comprobantes XML</h4>

                            <div class="row mt-3">

                                <div class="col-12 mb-3">
                                    <label>Partida</label>
                                    <select class="form-control w-50" [(ngModel)]="partidaActual.clave">
                    <option value="" disabled selected>Seleccione una partida</option>
                    <option *ngFor="let p of catalogoPartidas" [value]="p.clave">
                      {{ p.clave }} - {{ p.descripcion }}
                    </option>
                  </select>
                                </div>


                                <div class="col-12">

                                    <div class="border p-4 text-center mb-3" (drop)="onDropPartida($event)" (dragover)="$event.preventDefault()">
                                        <p>Arrastra XML aquí</p>
                                        <input type="file" #fileInput accept=".xml" (change)="onFileSelectedPartida($event)">
                                    </div>


                                    <table class="table table-sm table-bordered" *ngIf="partidaActual.xmls.length">

                                        <thead class="table-light">
                                            <tr>
                                                <th>Folio</th>
                                                <th>Proveedor</th>
                                                <th>RFC Emisor</th>
                                                <th>RFC Receptor</th>
                                                <th>Folio</th>
                                                <th>Fecha Timbrado</th>
                                                <th>Subtotal</th>
                                                <th>Total</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr *ngFor="let x of partidaActual.xmls">
                                                <td>
                                                    <span *ngIf="!x.editando; else editarFolio" (click)="x.editando = true">
                            {{ x.folio || 'Capturar folio' }}
                          </span>
                                                    <ng-template #editarFolio>
                                                        <input type="text" class="form-control form-control-sm" [(ngModel)]="x.folio" (blur)="x.editando = false" (keydown.enter)="x.editando = false" placeholder="Capturar folio" autofocus>
                                                    </ng-template>
                                                </td>
                                                <td>{{ x.nombre_emisor }}</td>
                                                <td class="text-nowrap">
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-truncate" style="max-width:120px">
                              {{ x.rfc_emisor }}
                            </span>
                                                        <button class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copyToClipboard(x.rfc_emisor)">
                              <i class="fa-regular fa-clipboard"></i>
                            </button>
                                                    </div>
                                                </td>
                                                <td class="text-nowrap">
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-truncate" style="max-width:120px">
                              {{ x.rfc_receptor }}
                            </span>
                                                        <button class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copyToClipboard(x.rfc_receptor)">
                              <i class="fa-regular fa-clipboard"></i>
                            </button>
                                                    </div>
                                                </td>
                                                <td class="text-nowrap">
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-truncate" style="max-width:180px">
                              {{ x.uuid }}
                            </span>
                                                        <button class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copyToClipboard(x.uuid)">
                              <i class="fa-regular fa-clipboard"></i>
                            </button>
                                                    </div>
                                                </td>

                                                <td>{{ x.fecha_sat }}</td>
                                                <td>{{ x.subtotal }}</td>
                                                <td>{{ x.total }}</td>

                                                <td>
                                                    <a class="btn btn-primary btn-sm" href="https://verificacfdi.facturaelectronica.sat.gob.mx/" target="_blank">
                            Verificar
                          </a>
                                                </td>

                                            </tr>
                                        </tbody>

                                    </table>
                                </div>

                                <div class="col-12 mt-4" *ngIf="partidaActual.xmls.length">

                                    <h6 class="mb-3">Configuración por XML</h6>

                                    <div class="row">

                                        <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let x of partidaActual.xmls; let i = index">

                                            <div class="card shadow-sm p-3 mb-3">

                                                <strong>XML {{ i + 1 }}</strong>
                                                <small>Folio: {{ x.folio }}</small>

                                                <label class="small mt-2">Número de factura</label>
                                                <input type="text" class="form-control form-control-sm" [(ngModel)]="x.numeroFactura">

                                                <label class="small mt-2">Bueno por</label>
                                                <input type="text" class="form-control form-control-sm" [(ngModel)]="x.buenoPor" (keydown)="validarEntrada($event, x)" (input)="calcularRestante(x)">

                                                <small class="text-muted">
                          Resta: $ {{ x.restante | number:'1.2-2' }}
                        </small>

                                                <label class="small mt-2">ISR</label>
                                                <input type="number" class="form-control form-control-sm" [(ngModel)]="x.isr">

                                                <label class="small mt-2">Tipo de persona</label>
                                                <select class="form-select form-select-sm" [(ngModel)]="x.tipoPersona">
                          <option value="FISICA">Persona Física</option>
                          <option value="MORAL">Persona Moral</option>
                        </select>

                                                <label class="small mt-2">Código Postal</label>
                                                <input type="text" class="form-control form-control-sm" [(ngModel)]="x.codigoPostal">

                                                <div class="form-check mt-3">
                                                    <input class="form-check-input" type="checkbox" [checked]="x.observacion === 'COMPARTIDA'" (change)="x.observacion = $event.target.checked ? 'COMPARTIDA' : 'NO COMPARTIDA'" id="compartida{{i}}">

                                                    <label class="form-check-label" for="compartida{{i}}">
                            Factura compartida
                          </label>
                                                </div>

                                                <button class="btn btn-danger btn-sm mt-3 w-100" (click)="eliminarXMLPartida(i)">
                          Eliminar
                        </button>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div class="text-center mt-3" *ngIf="partidaActual.xmls.length">
                                <button class="btn btn-success btn-sm px-4" [disabled]="!partidaActual.clave" (click)="confirmarPartida()">
                  Agregar partida
                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer-asig">
                <button class="btn-cancelar" (click)="cerrarAgregarXML()">Cerrar</button>

                <button class="btn-agregar" *ngIf="modo !== 'ver'" [disabled]="!empleadoSeleccionado" (click)="modo === 'editar' ? editComprobacion() : guardarComprobacion()">
          {{ modo === 'editar' ? 'Actualizar' : 'Guardar' }}
        </button>
            </div>

        </div>
    </div>
</div>
<div class="modal fade" id="observacion" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered my-modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header custom-header">
                <h5 class="modal-title">Observación</h5>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Cerrar">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div *ngIf="observacionSeleccionada">
                    <h6>{{ observacionSeleccionada.observacion }}</h6>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-outline-danger" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>